import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { easing, speed } from '../animations';
import { LoopModeEnum } from '../enums/loop-mode.enum';

@Directive({
  standalone: false,
  selector: '[campusStickerImage], [stickerImage], campus-sticker-image',
})
export class StickerImageDirective {
  @HostBinding('class.ui-sticker__image')
  hasStickerImageClass = true;
}
@Component({
  standalone: false,
  selector: 'campus-sticker',
  templateUrl: './sticker.component.html',
  styleUrls: ['./sticker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fill', [
      state('fill', style({ clipPath: 'inset({{initialProgress}}% 0 0 0)' }), {
        params: { initialProgress: 0 },
      }),
      state('fill', style({ clipPath: 'inset({{currentProgress}}% 0 0 0)' }), {
        params: { currentProgress: 0 },
      }),
      transition(
        'void => fill',
        [
          style({ clipPath: 'inset({{initialProgress}}% 0 0 0)' }),
          animate(`${speed.verySlow} ${easing.easeIn}`, style({ clipPath: 'inset({{currentProgress}}% 0 0 0)' })),
        ],
        {
          params: { initialProgress: 0, currentProgress: 0 },
        }
      ),
    ]),
  ],
})
export class StickerComponent implements OnChanges {
  @Input() progress: number;
  @Input() mode: LoopModeEnum;
  @Input() useFillAnimation: boolean;

  @HostBinding('class.ui-sticker') hasStickerClass = true;
  @HostBinding('class.ui-sticker--large') @Input() large = false;

  @Output() fillAnimationDone: EventEmitter<void> = new EventEmitter();

  public fillAnimation;
  public loopModes: typeof LoopModeEnum = LoopModeEnum;
  public fillStyle = {};

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.useFillAnimation && changes.progress) {
      this.fillStyle = {
        clipPath: `inset(${100 - changes.progress.currentValue}% 0 0 0)`,
        webkitClipPath: `inset(${100 - changes.progress.currentValue}% 0 0 0)`,
      };
    }
    if (this.useFillAnimation && changes.progress) {
      if (!changes.progress.isFirstChange()) {
        this.fillAnimation = {
          value: 'fill',
          params: {
            initialProgress: 100 - changes.progress.previousValue || 0,
            currentProgress: 100 - changes.progress.currentValue || 0,
          },
        };
      } else {
        this.fillAnimation = {
          value: 'void',
          params: {
            initialProgress: 100 - changes.progress.currentValue || 0,
          },
        };
      }
    }
  }

  animDone(event: AnimationEvent) {
    if (this.useFillAnimation && event.fromState !== event.toState) {
      this.fillAnimationDone.emit();
    }
  }
}
